export const renderHiddenToken = (token: string) => {
  if (token.length <= 2) return token;

  return (
    token.charAt(0) +
    "*".repeat(token.length - 2) +
    token.charAt(token.length - 1)
  );
};

export const lmcInputClass =
  "w-full [&_input]:border-gray-800 [&_input:focus]:border-gray-800";

export const lmcFieldClass =
  "bg-gray-900 rounded-none border-0 border-b-2 " +
  "text-white text-base md:text-base font-normal font-figtree leading-normal " +
  "focus:ring-0 focus:text-white focus:rounded-[5px]";
